module.exports = __webpack_public_path__ + "img/voucher_failed.6bb1e744.svg";